import styled from 'styled-components';

const Setting = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: border-box;
  height: 100%;

  text-align: left;

  ${({ theme }) => theme.devices.tablet`
    flex-direction: row;
    align-items: center;
  `}
`;

export default Setting;
